import { useParams, Link } from 'react-router-dom'
import axios from 'axios'
import { useAuthHeader } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import Table from '../../usables/Table'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'

export default function  Subject() {
  const { id } = useParams();
  const auth  = useAuthHeader()
  const [subject, setSubject] = useState({id:{}, subject_name: {}, teacher: []})
  const [subjectTeachers, setSubjectTeachers] = useState([])
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})

  const tableColumns = [{
    Header: "Mokytojai",
    columns: [
      {
        Header: "Vardas",
        accessor: "person.name"
      },
      {
        Header: "Pavardė",
        accessor: "person.lastname"
      },
      {
        Header: "Veiksmai",
        accessor: "action"
      }
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }
  useEffect(() => {
    axios.get(process.env.REACT_APP_API + `/subject/${id}`, config)
    .then(res => {
      if(res.status === 200){
        // console.log(res.data.subject.teacher)
        setSubjectTeachers([]) //! Pašalinti prieš buildinant
        res.data.subject.teacher.forEach((teach) => {
          // console.log(teach)
          teach.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/teachers/' + teach.id}>Daugiau</Link>
          setSubjectTeachers(subjectTeachers => [...subjectTeachers, teach ])
          // res.data.subject.teacher.action = <Link className='text-violet-500 hover:text-violet-700' to={'/teachers/' + res.data.subject.teacher.id}>Daugiau</Link>
        })
        setSubject(res.data.subject)
        setDataLoaded({done: true, sucssess: true, items: res.data.subject.teacher.length})
      }
    })
    .catch(err => {
      //console.log(err.response.data)
      setSubject(err.response.data)
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {dataLoaded.sucssess ? <h2>{subject.subject_name}</h2> : null}
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <Table columns={tableColumns} data={subjectTeachers} />
          : <ClosingAlert type='warning' message={'Nerasta mokytojų mokančių ' + subject.subject_name.toLowerCase()} />
        : <ClosingAlert type='error' message='Nerastas mokomasis dalykas' />
      }
    </>
  )
}